import { CatalogTable, type CatalogTableColumnsFunc } from '@backstage/plugin-catalog';

export const catalogColumns: CatalogTableColumnsFunc = context =>
  CatalogTable.defaultColumnsFunc(context)
    .filter(column => column.field !== 'entity.spec.lifecycle')
    .map(column =>
      column.field === 'resolved.entityRef' ? { ...column, defaultSort: 'asc' as const } : column,
    );
